export default "__VITE_ASSET__iNwv_1my__"